import React from "react";
import { useLocation, useNavigate } from "react-router";
import { useScannerContext } from "@/features/scanners/ScannerContext";

const NavigationScanListener: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pendingNavigationTarget, clearPendingNavigationTarget, clearScannedData } = useScannerContext();

  React.useEffect(() => {
    if (!pendingNavigationTarget) {
      return;
    }

    clearScannedData();

    const currentTarget = `${location.pathname}${location.search}${location.hash}`;
    if (currentTarget !== pendingNavigationTarget) {
      navigate(pendingNavigationTarget);
    }

    clearPendingNavigationTarget();
  }, [clearPendingNavigationTarget, clearScannedData, location.hash, location.pathname, location.search, navigate, pendingNavigationTarget]);

  return null;
};

export default NavigationScanListener;
